import 'moment-duration-format'

export const Hours = 'h',
  Minutes = 'm',
  Seconds = 's',
  MilliSeconds = 'S'

export const DefaultTimeTemplates = {
  Millis: `${MilliSeconds}`,
  SecondsMillis: `${Seconds}.${MilliSeconds}${MilliSeconds}`,
  MinutesSeconds: `${Minutes}:${Seconds}${Seconds}`,
  HoursMinutesSeconds: `${Hours}:${Minutes}${Minutes}:${Seconds}${Seconds}`
}

type TimeTemplateProducer = () => string

export type TimeTemplate = TimeTemplateProducer | string

type UnitOfTrimV1 = 'left' | 'right'
type UnitOfTrim = (
    'large' | 'small' | 'both' |
    'mid' | 'all' | 'final'
)

interface DurationFormatSettings {
  trim?: false | UnitOfTrimV1 | UnitOfTrim | string | Array<UnitOfTrim | string>
  largest?: number
  trunc?: true
  stopTrim?: string

  minValue?: number
  maxValue?: number

  useGrouping?: boolean
  precision?: number
  decimalSeparator?: string
  groupingSeparator?: string
  grouping?: number[]

  useSignificantDigits?: true

  forceLength?: boolean
  template?: string | TemplateFunction

  userLocale?: string
  usePlural?: boolean
  useLeftUnits?: boolean
  useToLocaleString?: boolean
}

type TemplateFunction = ((this: DurationFormatSettings) => string)

export interface TimeFormatSettings {
  trim?: false | UnitOfTrimV1 | UnitOfTrim | string | Array<UnitOfTrim | string>
  largest?: number
  trunc?: true
  stopTrim?: string

  minValue?: number
  maxValue?: number

  useGrouping?: boolean
  precision?: number
  decimalSeparator?: string
  groupingSeparator?: string
  grouping?: number[]

  useSignificantDigits?: true

  forceLength?: boolean
  template?: string | TemplateFunction

  userLocale?: string
  usePlural?: boolean
  useLeftUnits?: boolean
  useToLocaleString?: boolean
}
